export default {
    colors: [
        '#00949E',
        '#163662',
        '#F6AE2D',
        '#E16F37',
        '#F24236',
        '#75485E',
    ],

    complianceLabels: {
        COMPLIANT: 'Compliant',
        NONCOMPLIANT: 'Non-Compliant',
        NA: 'N/A',
    },

    userLabels: {
        'EO_ADMINS': 'EO Admins',
        'APPROVED_EOS': 'Approved EO Users',
        'UNAPPROVED_EOS': 'Unapproved EO Users',
        'UNACCPETED_EOS': 'Incomplete EO registrations',
    },

    equipmentBreakdownLabels: {
        'ONROAD_DIESEL_COVERED': 'On-Road Diesel',
        'NON_ROAD_DIESEL_COVERED': 'Non-Road Diesel',
        'DIESEL_NON_COVERED': 'Uncovered Diesel',
        'NON_DIESEL_NON_COVERED': 'Uncovered Non-Diesel',
    },

    exemptionBreakdownLabels: {
        'EMERGENCY': 'Emergency',
        'NO_RENTAL': 'No Rental',
        'UNIQUE': 'Unique',
        'SAFETY': 'Safety',
        'COBID': 'Cobid',
        'RENEWABLE': 'Renewable',
    },

    companyBreakdownLabels: {
        'NON_COBID': 'Non-COBID',
        'COBID': 'COBID'
    }
}